<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-12 mx-auto">
                <div class="card">
                    <div class="card-body">
                        <div class="row" style="justify-content: center;">
                            <div class="col-3">
                                <button v-if="selectedItems.length == 0" class="btn btn-primary mt-3"
                                    @click="carregarRateiosExistentes">
                                    Carregar
                                </button>
                            </div>
                        </div>
                        <div v-if="exibirElementoRateio">
                            <div v-if="$store.state.item.status == 'criacao'">
                                <div>
                                    <button type="button" class="btn btn-primary btn-sm float-end m-2"
                                        @click="statusLancamento()">
                                        Finalizar Lançamento
                                    </button>
                                </div>
                                <!-- Campo de Autocomplete -->
                                <input type="text" class="form-control mb-3" placeholder="Digite para buscar..."
                                    v-model="searchQuery" @input="fetchResults" v-if="$store.state.item.caps_id == capsid" />

                                <!-- Sugestões -->
                                <ul v-if="searchResults.length > 0" class="list-group">
                                    <li v-for="item in searchResults" :key="item.id"
                                        class="list-group-item list-group-item-action" @click="addToTable(item)">
                                        {{ item.nome }} - {{ item.saldo }}
                                    </li>
                                </ul>
                            </div>
                            <div class="row mt-3">
                                <div class="col"><p v-if="$store.state.somaRateio"><b>Soma Rateio: {{
                                    $store.state.somaRateio | formatCurrency }}</b>
                                </p></div>
                                <div class="col">
                                    <p><b>Valor Comprovante: {{ $store.state.item.valor_comprovante }}</b></p>
                                </div>
                                <div class="col">
                                    <button type="button" class="btn btn-primary btn-sm mb-2 float-end"
                                        @click="exportarXLSX(selectedItems)">
                                        ExportarXLSX
                                    </button>
                                </div>
                            </div>

                            <!-- Tabela com Registros Selecionados -->
                            <div v-if="selectedItems.length > 0" class="mt-4">
                                <h5>Registros Selecionados</h5>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Nome</th>
                                            <th>Código Reduzido</th>
                                            <th>Valor Rateio</th>
                                            <th v-if="$store.state.item.status == 'criacao'">Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in selectedItems" :key="item.id">

                                            <td>{{ item.nome }}</td>
                                            <td>{{ item.cod_conta_caixa_paciente || item.conta_contabil_reduzido }}</td>
                                            <td>
                                                <input type="text" class="form-control"
                                                    v-model="item.valor_rateio_paciente"
                                                    @input="aplicarMascaraLanRat($event, item)"
                                                    placeholder="Valor Rateio..." :disabled="styleRateio" />
                                            </td>
                                            <td>
                                                <button v-if="$store.state.item.status == 'criacao'"
                                                    class="btn btn-danger btn-sm"
                                                    @click="removeItem(index, item.lan_desc_cx_id, item.id)">Remover</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="load_update" class="overlay">
            <div class="spinner">Processando...</div>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
export default {
    props: ['nivelacesso', 'capsid', 'rateiosalvar'],
    watch: {
        rateiosalvar() {
            this.salvarTodosRegistros()
        }
    },
    data() {
        return {
            searchQuery: '',
            searchResults: [],
            selectedItems: [],
            paciente_id: '',
            load_update: false,
            exibirElementoRateio: false,
        };
    },
    methods: {
        exportarXLSX(data) {
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Planilha");

            XLSX.writeFile(workbook, "dados.xlsx");
        },
        fetchResults() {
            if (this.searchQuery.length < 2) {
                this.searchResults = [];
                return;
            }

            // Busca nos pacientes já carregados no store
            const searchTerm = this.searchQuery.toLowerCase();
            const allPatients = this.$store.state.pacientes_cx || [];

            this.searchResults = allPatients.filter(patient =>
                patient.nome.toLowerCase().includes(searchTerm)
            );
        },
        async carregarRateiosExistentes() { 
            try {
                const response = await axios.get(`https://contasmoradores.candido.org.br/api/v1/caixinha?filtro=lan_desc_cx_id:=:${this.$store.state.item.id}`);
                this.selectedItems = response.data.map(item => ({
                    id: item.id,
                    nome: item.nome_paciente,
                    cod_conta_caixa_paciente: item.cod_conta_caixa_paciente,
                    centro_custo: item.centro_custo_paciente,
                    valor_rateio_paciente: item.valor_paciente,
                    lan_desc_cx_id: item.lan_desc_cx_id,
                    paciente_id: item.paciente_id
                }));
                this.calcularSomaRateio();
                this.chamarAtualizarSaldo()
                this.exibirElementoRateio = true
            } catch (error) {
                console.error("Erro ao carregar rateios existentes:", error);
            }
        },
        addToTable(item) {
            this.load_update = true
            if (!this.selectedItems.some(i => i.nome === item.nome)) {
                this.selectedItems.push({ ...item, valor_rateio_paciente: 0.00 });
            }

            this.searchResults = [];
            this.searchQuery = '';
            this.calcularSomaRateio();
            this.load_update = false
        },
        removeItem(index, lan_desc_cx_id, id) {
            this.load_update = true
            if (!lan_desc_cx_id) {
                this.selectedItems.splice(index, 1);
                this.calcularSomaRateio();
                this.load_update = false
                return
            }

            let confirmacao = confirm('Confirmar remoção do registro!')

            if (!confirmacao) return false

            let formData = new FormData()
            formData.append('_method', 'delete')

            let config = {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/caixinha' + '/' + id, formData, config)
                .then(response => {
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = response.data
                    this.carregarRateiosExistentes();
                })
                .catch(errors => {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                    this.load_update = false
                })
                .finally(() => {
                    this.load_update = false
                })
        },
        calcularSomaRateio() {
            // Calcula a soma dos valores de rateio, convertendo para número corretamente
            const soma = this.selectedItems.reduce((total, item) => {
                // Converte a string formatada para número, se necessário
                const valor = this.converterParaNumero(item.valor_rateio_paciente) || 0;
                return total + valor;
            }, 0); // Valor inicial do acumulador é 0

            // Atualiza o estado do Vuex com a soma calculada
            this.$store.commit('setSomaRateio', soma);
        },
        converterParaNumero(valor) {
            if (!valor) return 0; // Retorna 0 se for vazio ou null

            if (typeof valor === 'number') return valor; // Se já for número, retorna direto

            // Remove pontos (separadores de milhar) e troca vírgula por ponto
            valor = valor.replace(/\./g, '').replace(',', '.');

            return parseFloat(valor) || 0;
        },
        async salvarTodosRegistros() {
            if (!this.verificaSomaRateio()) return;

            this.load_update = true;
            let erros = [];

            try {
                // Separar registros novos e existentes
                const novosRegistros = this.selectedItems.filter(item => !item.lan_desc_cx_id);
                const registrosExistentes = this.selectedItems.filter(item => item.lan_desc_cx_id);

                // Salvar novos registros
                if (novosRegistros.length) {
                    const errosNovos = await this.salvarRegistro(novosRegistros);
                    erros.push(...errosNovos);
                }

                // Atualizar registros existentes
                if (registrosExistentes.length) {
                    const errosExistentes = await this.atualizarRegistro(registrosExistentes);
                    erros.push(...errosExistentes);
                }

                await this.carregarRateiosExistentes();

                if (erros.length) {
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: `Foram encontrados ${erros.length} erros ao salvar registros.`,
                        dados: erros
                    }
                } else {
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = 'Registros salvos com sucesso!'
                }
            } catch (err) {
                this.$store.state.transacao.status = 'erro'
                this.$store.state.transacao.mensagem = {
                    mensagem: `Erro inesperado em salvarTodosRegistros: ${err}`,
                    dados: err
                }
            } finally {
                this.load_update = false;
            }
        },

        async salvarRegistro(registros) { 
            let erros = [];
            const promises = registros.map(registro => {
                let formData = new FormData();
                formData.append('nome_paciente', registro.nome);
                formData.append('cod_conta_caixa_paciente', registro.conta_contabil_reduzido);
                formData.append('centro_custo_paciente', registro.centro_custo);
                formData.append('valor_paciente', registro.valor_rateio_paciente);
                formData.append('historico_paciente', '0040');
                formData.append('tipo_operacao', this.$store.state.item.tipo_operacao);
                formData.append('lan_desc_cx_id', this.$store.state.item.id);
                formData.append('paciente_id', registro.id);
                formData.append('caps_id', this.capsid);
                formData.append('data_lancamento', this.$store.state.item.data_lancamento);
                formData.append('descricao', this.$store.state.item.descricao);

                let config = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': this.token
                    }
                };

                return axios.post('https://contasmoradores.candido.org.br/api/v1/caixinha', formData, config)
                    .catch(error => {
                        console.log(error.response.data)
                        erros.push({ registro, error });
                    });
            });

            await Promise.all(promises);
            return erros;
        },

        async atualizarRegistro(registros) {
            let erros = [];
            const promises = registros.map(registro => {
                let formData = new FormData();
                formData.append('_method', 'patch');
                formData.append('nome_paciente', registro.nome);
                formData.append('cod_conta_caixa_paciente', registro.cod_conta_caixa_paciente);
                formData.append('centro_custo_paciente', registro.centro_custo);
                formData.append('valor_paciente', registro.valor_rateio_paciente);
                formData.append('tipo_operacao', this.$store.state.item.tipo_operacao);
                formData.append('paciente_id', registro.paciente_id);
                formData.append('caps_id', this.capsid);
                formData.append('data_lancamento', this.$store.state.item.data_lancamento);
                formData.append('descricao', this.$store.state.item.descricao);

                let config = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': this.token
                    }
                };

                return axios.post(`https://contasmoradores.candido.org.br/api/v1/caixinha/${registro.id}`, formData, config)
                    .catch(error => {
                        console.log(error.response.data)
                        erros.push({ registro, error });
                    });
            });

            await Promise.all(promises);
            return erros;
        },
        verificaSomaRateio() {
            let number = typeof this.$store.state.item.valor_comprovante === 'string' ? parseFloat(this.$store.state.item.valor_comprovante.replace(/\./g, '').replace(',', '.')) : this.$store.state.item.valor_comprovante;

            // Formata para moeda brasileira (R$ 1.000,00)
            number.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            if (number != parseFloat(this.$store.state.somaRateio.toFixed(2))) {
                alert('A soma do reteio precisa ser igual ao valor do comprovante!')
                return false
            }

            return true
        },
        async statusLancamento() {
            if (!this.$store.state.item.imagem) {
                let confirmacao = confirm('Insira a Nota Fiscal')
                if (!confirmacao || confirmacao) return false
            }
            if (!this.verificaSomaRateio()) return
            let confirmacao = confirm('Após confirmar não será mais possvível editar!')

            if (!confirmacao) return false

            await this.salvarTodosRegistros()

            let formData = new FormData()
            formData.append('_method', 'patch')
            formData.append('status', 'finalizado')
            formData.append('caps_id', this.$store.state.item.caps_id)


            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Accept': 'application/json',
                    'Authorization': this.token
                }
            }

            axios.post('https://contasmoradores.candido.org.br/api/v1/lan_caixinha' + '/' + this.$store.state.item.id, formData, config)
                .then(response => {
                    this.$store.state.item.status = 'finalizado'
                    this.$store.state.transacao.status = 'sucesso'
                    this.$store.state.transacao.mensagem = 'Lançamento Finalizado com sucesso!'
                })
                .catch(errors => {
                    console.log(errors.response.data)
                    this.$store.state.transacao.status = 'erro'
                    this.$store.state.transacao.mensagem = {
                        mensagem: errors.response.data.mensagem,
                        dados: errors.response.data.errors
                    }
                })
        },
        aplicarMascaraLanRat(event, item) {
            let valor = event.target.value;

            // Remove todos os caracteres que não são números
            valor = valor.replace(/\D/g, '');

            // Se estiver vazio, evita erro e mantém a string vazia
            if (valor === '') {
                item.valor_rateio_paciente = '';
                return;
            }

            // Converte para número e divide por 100 para formatar como decimal
            valor = (parseInt(valor, 10) / 100).toFixed(2);

            // Formata o valor no padrão brasileiro (vírgula decimal, pontos para milhar)
            valor = valor.replace('.', ',');
            valor = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

            // Atualiza o valor no item do array
            item.valor_rateio_paciente = valor;

            // Atualiza a interface do input
            this.$nextTick(() => {
                event.target.value = valor;
            });

            // Atualiza a soma do rateio
            this.calcularSomaRateio();
        },
        chamarAtualizarSaldo() {
            this.$emit('atualizar-saldo')
        }

    },
    mounted() {
    },
    computed: {
        styleRateio() {
            if (this.nivelacesso == 'user' && this.$store.state.item.status != 'criacao') {
                //return 'pointer-events: none; mix-blend-mode: multiply'
                return true
            }
            if (this.nivelacesso == 'adm' && (this.$store.state.item.status == 'finalizado' || $store.state.item.aprovacao == 'sim')) {
                //return 'pointer-events: none; mix-blend-mode: multiply'
                return true
            }
            return false
        }
    }
}
</script>

<style scoped>
.list-group-item {
    cursor: pointer;
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, #ff6b6b, #feca57, #48dbfb, #1dd1a1);
    background-size: 800% 800%;
    animation: gradientAnimation 10s ease infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    opacity: 0.6;
}

.spinner {
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

@keyframes gradientAnimation {
    0% {
        background-position: 0% 50%;
    }

    50% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0% 50%;
    }
}
</style>